import {
  L12M,
  L12M_ABBR,
  L30D,
  L30D_ABBR,
  N30D_ABBR,
} from "./constants/filterConstants";

export const getPeriodAbbreviation = (period: string) => {
  switch (period) {
    case L30D:
      return L30D_ABBR;
    case L12M:
      return L12M_ABBR;
    default:
      return N30D_ABBR;
  }
};

export const getLowerCaseThreeCharPeriodLabel = (period: string) =>
  getPeriodAbbreviation(period).slice(0, 3).toLowerCase();
